import { gql } from "lib/apolloClient";

// this mutation includes or excludes units from all the mapped grades
export const updateUnitPlanInclusionStatusMutation = gql`
  mutation updateUnitPlanInclusionStatus(
    $input: updateUnitPlanInclusionStatusInInsightInput!
  ) {
    planner {
      updateUnitPlanInclusionStatusInInsights(input: $input)
    }
  }
`;

// this mutation includes or excludes units from a specific grade
export const updateUnitPlanInclusionInGradeMutation = gql`
  mutation updateUnitPlanInclusionInGrade(
    $input: PYPPOIUnitGradeMappingUpdateInput!
  ) {
    planner {
      upsertPYPPOIUnitGradeMapping(input: $input)
    }
  }
`;
